export type AreaNamePrefix = '인쇄 영역' | '원형' | '다각형';

/** `${prefix} ${n}` 중 아직 쓰지 않은 가장 작은 n(1부터)으로 새 인쇄 영역 이름을 만든다. */
export const nextAreaName = (prefix: AreaNamePrefix, existing: readonly string[]): string => {
  const taken = new Set(existing);
  let n = 1;
  while (taken.has(`${prefix} ${n}`)) n += 1;
  return `${prefix} ${n}`;
};
